(function () {
  'use strict';

  if (window.__anacotteConversionTrackingV1) return;
  window.__anacotteConversionTrackingV1 = true;

  var GA4_DESTINATION = 'G-BX34C51ES6';
  var onceKeys = Object.create(null);

  function baseParams(extra) {
    return Object.assign({
      page_path: window.location.pathname,
      page_title: document.title,
      page_language: document.documentElement.lang || 'en'
    }, extra || {});
  }

  function sendToGoogle(eventName, params, attempt) {
    attempt = attempt || 0;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, Object.assign({ send_to: GA4_DESTINATION }, params));
      return;
    }

    if (attempt < 10) {
      window.setTimeout(function () {
        sendToGoogle(eventName, params, attempt + 1);
      }, 500);
    }
  }

  function emit(eventName, extra, options) {
    var params = baseParams(extra);
    var key = options && options.onceKey;

    if (key && onceKeys[key]) return;
    if (key) onceKeys[key] = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
    sendToGoogle(eventName, params);
    document.dispatchEvent(new CustomEvent('anacotte:conversion', {
      detail: Object.assign({ event: eventName }, params)
    }));
  }

  function forwardExistingEvent(eventName) {
    document.addEventListener('anacotte:' + eventName, function (event) {
      var detail = event.detail || {};
      sendToGoogle(eventName, baseParams({
        form_id: detail.form_id || undefined,
        step: detail.step || undefined
      }));
    });
  }

  function isLeadForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) return false;

    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/contact') !== -1 || !!form.querySelector('[name^="contact["]');
  }

  function formType(form) {
    var identity = ((form.id || '') + ' ' + (form.className || '')).toLowerCase();
    if (identity.indexOf('quote') !== -1) return 'quote';
    if (identity.indexOf('resource-guide') !== -1) return 'resource_guide';
    if (identity.indexOf('industry') !== -1 || identity.indexOf('food-brand') !== -1) return 'industry_brief';
    return 'contact';
  }

  function bindForms() {
    Array.prototype.slice.call(document.forms).forEach(function (form) {
      if (!isLeadForm(form) || form.dataset.anacotteTrackingBound === 'true') return;
      form.dataset.anacotteTrackingBound = 'true';

      var type = formType(form);
      var id = form.id || type;

      form.addEventListener('focusin', function () {
        emit('lead_form_start', { form_id: id, form_type: type }, { onceKey: 'start:' + id });
      }, { once: true });

      form.addEventListener('submit', function () {
        emit('lead_form_submit', { form_id: id, form_type: type });
      });
    });
  }

  function fileNameFromUrl(href) {
    try {
      return new URL(href, window.location.href).pathname.split('/').pop() || 'download';
    } catch (error) {
      return 'download';
    }
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var lowerHref = href.toLowerCase();
      var text = (link.textContent || '').trim().toLowerCase();

      if (lowerHref.indexOf('.pdf') !== -1 || lowerHref.indexOf('anacotte-packaging-rfq-and-validation-checklist') !== -1) {
        emit('rfq_checklist_download', { file_name: fileNameFromUrl(href) });
        return;
      }

      if (lowerHref.indexOf('mailto:') === 0) {
        emit('email_click', { destination_type: 'email' });
        return;
      }

      if (lowerHref.indexOf('tel:') === 0) {
        emit('phone_click', { destination_type: 'phone' });
        return;
      }

      if ((lowerHref.indexOf('wa.me/') !== -1 || lowerHref.indexOf('whatsapp.com/') !== -1) && !link.hasAttribute('data-contact-channel')) {
        emit('whatsapp_click', { destination_type: 'whatsapp' });
        return;
      }

      if (lowerHref.indexOf('/pages/get-a-quote') !== -1 || lowerHref.indexOf('/pages/contact') !== -1 || lowerHref.indexOf('/pages/contact-us') !== -1) {
        emit('quote_cta_click', { destination_path: lowerHref.split('?')[0] });
        return;
      }

      if (lowerHref.indexOf('sample') !== -1 || text.indexOf('request sample') !== -1 || text.indexOf('order sample') !== -1) {
        emit('sample_request_click', { destination_path: lowerHref.split('?')[0] });
      }
    });
  }

  function trackConfirmedLead() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;

    var storageKey = 'anacotte:lead:' + window.location.pathname + ':' + window.location.search;
    try {
      if (window.sessionStorage.getItem(storageKey)) return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      // Continue without storage when the browser blocks it.
    }

    emit('generate_lead', { lead_source: 'shopify_contact_form' }, { onceKey: storageKey });
  }

  forwardExistingEvent('quote_start');
  forwardExistingEvent('quote_step_complete');
  forwardExistingEvent('quote_submit');
  document.addEventListener('anacotte:contact-click', function (event) {
    sendToGoogle('whatsapp_click', baseParams({ destination_type: 'whatsapp' }));
  });

  function init() {
    bindForms();
    bindClicks();
    trackConfirmedLead();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
